import $ from 'jquery';
import { View } from 'backbone.marionette';
import Handlebars from 'handlebars';

const TutorialOtherActionsDropdown = View.extend({
  constructor(container) {
    this.container = $(container);
    this.renderer = Handlebars.compile($('#other-actions-dropdown-tpl').html());

    SOPHIA.publisher.publishingState.addChangeStateCallback(() => {
      this._publishingStateChanged();
    });

    this.render();
  },

  showReport() {
    // Ensure both has the same type (string)
    return `${SOPHIA.tutorial.author_id}` !== `${SOPHIA.currentUserId()}`;
  },

  showDropdown() {
    return this.showReport();
  },

  render() {
    if (this.showDropdown()) {
      const renderer_args = {
        showReport: this.showReport()
      };

      this.container.html(this.renderer(renderer_args));
      $('.flexible-right', this.container).actionGearDark();
      $('.abuse', this.container).reportAbuse({reportArea: 'tutorial'});

      $('.copy_tutorial_link', this.container).on('click', (e) => {
        e.preventDefault()
        const url = $(e.currentTarget).data('url')
        const xhrData = {
          url,
          type: 'POST',
          dataType: 'json'
        }

        SOPHIA.sendXHR(xhrData).then(response => {
          window.open(response.tutorial_url, '_blank')
        })
      })
    } else {
      this.container.html('');
    }
  },

  _publishingStateChanged() {
    this.render();
  }
});

export default TutorialOtherActionsDropdown;

if (!SOPHIA.tutorial) { SOPHIA.tutorial = {}; }
SOPHIA.tutorial.otherActionsDropdown = TutorialOtherActionsDropdown;
